import React from 'react'
import { DashboarCarddWrapper } from './style'
import CheckboxIcon2 from '../../images/CheckboxIcon2';
import { ShieldCheck, Lock } from "lucide-react";



function DashboardCard2({ number = "", heading = "", desc = "", img = null, complate = false, key, onClick = () => { }, disable }) {
    const cardClass = complate ? 'completed' : disable ? 'disabled' : 'current';
    return (
        <>
            {/* // <DashboarCarddWrapper key={key} onClick={disable ? () => { } : onClick} className={`transition-all duration-300 group hover:bg-[#4FA0FF] cursor-pointer ${cardClass}`}>
        //     <div className={`group-hover:bg-[#3A8CE6] transition-all duration-300 icons ${complate ? "active" : ""}`}>
        //         <img src={img} alt="icon" />



        //     </div>
        //     <div className="rightBox">
        //         <div className="header flex justify-between">
        //             <h2 className='  group-hover:text-white transition-all duration-300'>{heading}</h2>
        //             <CheckboxIcon2 color={complate ? "#FFD700" : "#E5E5E5"} number={number} />
        //         </div>
        //         <p className='group-hover:text-white mt-2 max-w-[250px]'>{desc}</p>
        //     </div> */}

            {/* // </DashboarCarddWrapper> */}
            <DashboarCarddWrapper
                onClick={disable ? () => { } : onClick}
                className={`group relative flex items-start gap-4 rounded-2xl bg-white p-5 shadow-sm border border-gray-100
          transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:border-[#4FA0FF]
          ${cardClass}`}
            >
                {/* Left Icon */}
                <div
                    className={`w-14 h-14 rounded-full flex items-center justify-center flex-shrink-0
            transition-all duration-300 group-hover:scale-105
            ${complate ? "bg-[#4FA0FF]" : "bg-blue-100"}`}
                >
                    <img src={img} alt="" className="w-7 h-7 object-contain" />
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0">
                    <h2 className="text-lg font-semibold text-[#173A7A] group-hover:text-[#4FA0FF] transition-colors">
                        {heading}
                    </h2>

                    <p className="mt-2 text-sm leading-6 text-gray-500">
                        {desc}
                    </p>
                </div>

                {/* Right Circle */}
                <div className="flex-shrink-0">
                    <CheckboxIcon2
                        color={complate ? "#FFD700" : "#D1D5DB"}
                        number={number}
                    />
                </div>
            </DashboarCarddWrapper>




        </>

    )
}

export default DashboardCard2;